module.exports = __webpack_public_path__ + "static/media/9DESA23.bbf0aca4.jpg";